import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useCallback, useContext, useState } from "react";
import { AuthContext } from "../../../../contexts/AuthContext";
import SelectQuery from "../../../SelectQuery";

export default function ModalOrigemDestino({
    open,
    handleClose,
    onChangeOrigem,
    onChangeDestino,
    values,
    isFirstFilled = false
}: ModalOrigemDestinoProps) {

    const { userPerfilComLoja } = useContext(AuthContext);

    const [formValues, setFormValues] = useState({
        origem: values.origem,
        destino: values.destino
    })

    // Funções Manipuladoras
    const handleChangeFilter = useCallback((prop: "origem" | "destino", value: any) => {
        setFormValues(prevState => ({
            ...prevState,
            [prop]: value
        }))
    }, [])

    const handleSubmit = useCallback(() => {
        onChangeOrigem(formValues.origem)
        onChangeDestino(formValues.destino)
        handleClose()
    }, [formValues, onChangeOrigem, onChangeDestino, handleClose])
    //

    return (
        <Dialog
            open={open}
            onClose={!isFirstFilled ? handleClose : () => { }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Alterar dados
            </DialogTitle>
            <DialogContent>

                <Box
                    marginY={2}
                >
                    <SelectQuery
                        defaultValue={[formValues.origem]}
                        query="pesquisar-lojas"
                        type="field"
                        label="Origem"
                        titleModal="Selecionar Origem"
                        emptyLabel="-"
                        multiple={false}
                        returnOnlyId={false}
                        autoSelectFirst={true}
                        onChange={(values) => {
                            handleChangeFilter("origem", values[0]);
                        }}
                    />
                </Box>

                <Box
                    marginY={2}
                >
                    <SelectQuery
                        defaultValue={[formValues.destino]}
                        query="pesquisar-lojas"
                        type="field"
                        label="Destino"
                        titleModal="Selecionar Destino"
                        emptyLabel="-"
                        multiple={false}
                        returnOnlyId={false}
                        onChange={(values) => {
                            handleChangeFilter("destino", values[0]);
                        }}
                        extraParams={{ somente_vinculadas: Boolean(userPerfilComLoja?.loja) }}
                    />
                </Box>

            </DialogContent>
            <DialogActions>
                <Button
                    disabled={!formValues.destino || !formValues.origem || isFirstFilled}
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    autoFocus
                    disabled={!formValues.destino || !formValues.origem}
                    onClick={handleSubmit}
                >
                    Alterar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface ModalOrigemDestinoProps {
    values: any,
    open: boolean,
    handleClose: () => void,
    onChangeOrigem: (values: any[]) => void,
    onChangeDestino: (values: any[]) => void;
    isFirstFilled: boolean
}